/* eslint-disable import/no-anonymous-default-export */
import { desArrow } from '../../assets'
import { useState } from 'react';
import GenerateArrayStrings, { getVarType } from '../../components/GenerateArrayStrings'
import './GenAIDocumentDescriptor.css'

const formattedStringArr = (array, fn) => {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        var mapping = fn(array[i]);
        result = result.concat(mapping);
    }
    return result;
}
const divider = () => {
    return (
        <div className="gen-ai-document-item-description-divider"></div>
    )
}
const textFormatter = (data) => {
    const replacedString = data.replaceAll("%%##%%##", '%%##').replaceAll("%%##", '\n');
    //console.log(newString)
    const updatedText = formattedStringArr(replacedString.split('\n'), function (part) {
        return [part, <div>{divider()}</div>];
    });
    updatedText.pop()
    return (
        <div>
            {updatedText}
        </div>
    )
}
const renderForPubmed = (descriptorsTitle, data) => {
    let dataDescriptors = '';
    if (getVarType(data) === 'Array') {
        dataDescriptors = GenerateArrayStrings(data)
    }
    else {
        dataDescriptors = data;
    }
    return (
        <div>
            <div className="document-descriptor-title">
                <b><label>{descriptorsTitle}: </label></b>
            </div>
            <span>{dataDescriptors}</span>
        </div>
    )
}

export default function (props) {

    const [isOpen, setOpenDescriptor] = useState(false);
    const {
        docItemDescription, meshHeading, publicationType, substances, isPubMedHtml
    } = props

    if (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList' && !isPubMedHtml) {
        return (
            <div className="gen-ai-document-item-description">
                <div className="gen-ai-document-item-description__badge">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Document Item Description</title>
                        <g clip-path="url(#clip0_1446_8959)">
                            <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_1446_8959">
                                <rect width="16" height="16" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                    <span className="gen-ai-document-item-description__badge-label">Document Item Description</span>
                    <svg style={isOpen ? { transform: "rotate(180deg)", cursor: "pointer" } : { cursor: "pointer" }} onClick={e => setOpenDescriptor(!isOpen)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6L8 10L12 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {isOpen && <div className="gen-ai-document-item-description__card" role="region">
                    <div className="gen-ai-document-item-description__list">
                        
                            <div
                                className="gen-ai-document-item-description__row"
                                role="row"
                            >
                                {textFormatter(docItemDescription)}
                            </div>
                        
                    </div>
                </div>}

            </div>
        )
    } else {
        return (
            <div className="document-descriptor-wrapper" onClick={e => setOpenDescriptor(!isOpen)}>
                <div className="document-descriptor-header-wrapper">
                    <img src={desArrow} alt='Document Item Description' className={isOpen ? "document-descriptor-img-rotate" : "document-descriptor-img"} />
                    <span> Document Item Description</span>
                </div>
                {isOpen &&
                    <>
                        <div className="document-descriptor-text-wrapper">
                            {(publicationType && (getVarType(publicationType) !== 'Array' || (getVarType(publicationType) === 'Array' && publicationType.length > 0))) &&
                                <>
                                    {renderForPubmed('Publication type', publicationType)}
                                </>
                            }

                            {(meshHeading && (getVarType(meshHeading) !== 'Array' || (getVarType(meshHeading) === 'Array' && meshHeading.length > 0))) &&
                                <>
                                    {(publicationType && (getVarType(publicationType) !== 'Array' || (getVarType(publicationType) === 'Array' && publicationType.length > 0)))
                                        && divider()
                                    }
                                    {renderForPubmed('MeSH terms', meshHeading)}
                                </>
                            }
                            {(substances && (getVarType(substances) !== 'Array' || (getVarType(substances) === 'Array' && substances.length > 0))) &&
                                <>
                                    {(meshHeading && (getVarType(meshHeading) !== 'Array' || (getVarType(meshHeading) === 'Array' && meshHeading.length > 0))) && divider()}
                                    {renderForPubmed('Substances', substances)}
                                </>
                            }
                        </div>
                    </>
                }

            </div>
        )
    }

}